import { render, staticRenderFns } from "./Careers.vue?vue&type=template&id=65c21f68&scoped=true&"
import script from "./Careers.vue?vue&type=script&lang=js&"
export * from "./Careers.vue?vue&type=script&lang=js&"
import style0 from "./Careers.vue?vue&type=style&index=0&id=65c21f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c21f68",
  null
  
)

export default component.exports